/* eslint-disable @typescript-eslint/no-redeclare */
import { CommunityInvite } from '../models/inviteService.model';
import { SubscriptionType } from './misc';

export type Subscription = {
  subscriptionId: string;
  productId: string;
  active: boolean;
  willRenew: boolean;
  type: SubscriptionType;
};

export type MemberDashboard = {
  dashboardId: number;
};

export default interface Community {
  id: number;
  role: CommunityRole;
  inviteId: string | null;
  picture: string | null;
  name: string;
  description: string;
  type: CommunityType;
  memberCount?: number;
  inviteFields?: CommunityInvite;
  deprecated_communityId?: number;
  subscription?: Subscription;
  trialType?: SubscriptionType;
  trialEndDate?: string | Date;
  paidByBusiness?: boolean;
  dashboard?: MemberDashboard;
  features?: CommunityFeatures;
  memberPermissions?: CommunityMemberPermissions;
  wantedDashboardFeatures?: DashboardFeatures;
  tags?: number[];
}

export enum CommunityType {
  ROOMMATES = 'ROOMMATES',
  STUDENTGROUP = 'STUDENTGROUP',
  SPORTTEAM = 'SPORTTEAM',
  ASSOCIATION = 'ASSOCIATION',
  COLLEAGUES = 'COLLEAGUES',
  FAMILY = 'FAMILY',
  FRIENDS = 'FRIENDS',
  OTHER_COMMUNITY = 'OTHER_COMMUNITY',
}

export enum CommunityRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export interface Admin {
  adminId?: number;
  memberId?: number;
  userId?: number;
  role: CommunityRole;
  display: string;
  picture?: string;
  pending?: boolean;
  inviteId?: number;
  onboarding?: boolean;
}

/**
 * Model AdminInvite
 *
 */
export type AdminInvite = {
  inviteId: number;
  userId?: number;
  display: string;
  picture?: string;
  role: CommunityRole;
};

export type CommunityMemberPermissions = {
  [CATEGORY in
    | 'EVENTS'
    | 'MEMBERS'
    | 'STATS_AND_SCORES'
    | 'TASKS'
    | 'PHOTO_ALBUMS'
    | 'COST_SPLITTING'
    | 'WALL']?: {
    [OPERATION in 'CREATE' | 'UPDATE' | 'DELETE']?: boolean;
  };
};

export enum CommunityFeature {
  EASY_SHARING = 'EASY_SHARING',
  MEMBER_ADMINISTRATION = 'MEMBER_ADMINISTRATION',
  EVENTS = 'EVENTS',
  PARTICIPATION_INSIGHTS = 'PARTICIPATION_INSIGHTS',
  TASKS = 'TASKS',
  STATS_AND_SCORES = 'STATS_AND_SCORES',
  COMMUNICATION = 'COMMUNICATION',
  CHATS = 'CHATS',
  COST_SPLITTING = 'COST_SPLITTING',
  FINANCIAL_ADMINISTRATION = 'FINANCIAL_ADMINISTRATION',
  SALES = 'SALES',
  MARKETPLACE = 'MARKETPLACE',
  PHOTO_ALBUMS = 'PHOTO_ALBUMS',
  LOCATIONS = 'LOCATIONS',
  FILES = 'FILES',
  FORMS = 'FORMS',
  SCHEDULES = 'SCHEDULES',
  WALL = 'WALL',
  SPONSORS = 'SPONSORS',
}

export type CommunityFeatures = {
  [FEATURE in CommunityFeature]?: boolean;
};

export enum DashboardFeature {
  MEMBER_ADMINISTRATION = 'MEMBER_ADMINISTRATION',
  PARTICIPATION_INSIGHTS = 'PARTICIPATION_INSIGHTS',
  COMMUNICATION = 'COMMUNICATION',
  FINANCIAL_ADMINISTRATION = 'FINANCIAL_ADMINISTRATION',
  SPONSORS = 'SPONSORS',
}

export type DashboardFeatures = {
  [FEATURE in DashboardFeature]?: boolean;
};

export interface MemberDashboardDto {
  dashboardId: number;
  features: DashboardFeatures;
}

export enum BusinessAdminRole {
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
}

export interface MemberBusinessDto {
  businessId: number;
  role?: BusinessAdminRole;
}

export interface MemberCommunityDto {
  id: number;
  name: string;
  picture: string;
  memberCount: number;
  description: string;
  chatCount: number;
  role: CommunityRole;
  type: CommunityType;
  features: CommunityFeatures;
  memberPermissions: CommunityMemberPermissions;
  dashboard?: MemberDashboardDto;
  business?: MemberBusinessDto;
  trialType?: SubscriptionType;
  trialEndDate?: string | Date;
  paidByBusiness?: boolean;
  subscription?: {
    id: number;
    stripeSubscriptionId: string;
    stripeProductId: string;
    active: boolean;
    willRenew: boolean;
    type: SubscriptionType;
  };
}